// © Microsoft Corporation. All rights reserved.

import { AccentButton } from "@microsoft/fast-components-react-msft";
import { getContextData } from "@msnews/core";
import { logoImages, msaLogin, addOrUpdateTelemetryObject, dispatchTelemetryEvent, renderHybrid, TelemetryEventMap } from "@msnews/social-utils";
import React from "react";
import { SocialProps } from "../Social.props";
import { onboardingPageTelemetryContracts, OnboardingThirdPartyPageTelemetryObjects } from "./OnboardingPage.telemetry";

export default class OnboardingThirdPartyPage extends React.Component<SocialProps> {
    containerRef: HTMLDivElement;
    telemetryObjects:  OnboardingThirdPartyPageTelemetryObjects;

    constructor(props) {
        super(props);
        this.containerRef = null;
    }

    async signInThirdPartyMsaHandler(e) {
        try {
            const requestContext = this.props.requestContext;
            const locationHref = getContextData(requestContext.data.locationHref, "locationHref");
            await msaLogin(this.props.email, this.props.market, locationHref.split("?")[0]);
            this.props.usersConnector.fetchMe();
        } catch (e) {
        // Suppress the error
        }
    }

    async createNewMicrosoftAccountHandler(e) {
        const requestContext = this.props.requestContext;
        const locationHref = getContextData(requestContext.data.locationHref, "locationHref");
        await msaLogin(null, this.props.market, locationHref.split("?")[0], true);
        this.props.usersConnector.fetchMe();
    }

    componentDidUpdate() {
        if (this.props.me.isSocialUser) {
            this.props.popupConnector.closePopup();
        } else if (this.props.me.name) {
            this.props.popupConnector.openPopup("onboardingPage", { contentId: this.props.contentId });
        }
    }

    componentDidMount() {
        if (this.containerRef) {
            dispatchTelemetryEvent(TelemetryEventMap.genericLoaded, this.containerRef);
        }
    }

    render() {
        const { managedClasses, email, loginType, t, mainTelemetryObject, contentId, contents } = this.props;
        const cmsId = contentId && contents && contents[contentId] && contents[contentId].cmsId;

        /** Generate Telemetry Objects */
        if (mainTelemetryObject) {
            const containerTelemetryObject = addOrUpdateTelemetryObject(mainTelemetryObject, onboardingPageTelemetryContracts.onboardingThirdPartyPage, { id: cmsId }, this.telemetryObjects && this.telemetryObjects.main);
            this.telemetryObjects = {
                main: containerTelemetryObject,
                onboardingThirdPartyPageSignIn: addOrUpdateTelemetryObject(containerTelemetryObject, onboardingPageTelemetryContracts.onboardingThirdPartyPageSignIn, { id: cmsId }, this.telemetryObjects && this.telemetryObjects.onboardingThirdPartyPageSignIn),
                onboardingThirdPartyPageCreateAccount: addOrUpdateTelemetryObject(containerTelemetryObject, onboardingPageTelemetryContracts.onboardingThirdPartyPageCreateAccount, { id: cmsId }, this.telemetryObjects && this.telemetryObjects.onboardingThirdPartyPageCreateAccount)
            };
        }

        return (
            <div className={managedClasses.onboardingPageContainer} {...renderHybrid(this.telemetryObjects && this.telemetryObjects.main, true, (el) => { this.containerRef = el; })}>
                <img className="cwt-top-logo" src={logoImages.microsoftText} alt={t.ImgAltsMicrosoftLogo}/>
                <h2 className="cwt-title"> {t.OnboardingThirdPartyTitle} </h2>
                <p className="cwt-sub-title">
                    { t.OnboardingThirdPartySubTitle.replace("#provider#", loginType) }
                </p>
                <span className="cwt-email">
                    {email}
                </span>

                <div className="cwt-buttons">
                    <AccentButton
                        className="cwt-fast-button"
                        onClick={e => this.signInThirdPartyMsaHandler(e)}
                        {...renderHybrid(this.telemetryObjects && this.telemetryObjects.onboardingThirdPartyPageSignIn, false)}
                    > {t.OnboardingThirdPartySignIn} </AccentButton>
                </div>

                <span className="cwt-footer-text">
                    <a href="#" className="cwt-link"
                        onClick={e => this.createNewMicrosoftAccountHandler(e)}
                        {...renderHybrid(this.telemetryObjects && this.telemetryObjects.onboardingThirdPartyPageCreateAccount, false)}
                    > {t.OnboardingThirdPartyCreate} </a>
                </span>
            </div>
        );
    }
}